import PropTypes from 'prop-types';
import { Box, Dialog, Slide, Typography } from '@material-ui/core';
import MaterialGrid from '@material-ui/core/Grid';
import Slider from '@material-ui/core/Slider';
import { EditorConvertToHTMLActivity } from 'common/components/fields/EditorConvertToHTMLActivity';
import { SelectLabel } from 'common/components/fields/SelectLabel';
import { FORM_RULES } from 'helpers/validations';
import { setPreviewResult } from 'modules/owner/pages/lotties/lottiesActions';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field } from 'redux-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import Container from './styles';
import PrimaryButton from '../../buttons/primaryButton';

const marks = [
  {
    value: 0,
    label: ' 0%',
  },
  {
    value: 100,
    label: '100%',
  },
];

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function FaixaPreview({ input, index, onPreview }) {
  const id = input.value;
  const empty = !id || id === 'none';

  return (
    <button
      type="button"
      onClick={() => onPreview(index)}
      disabled={empty}
      style={{ opacity: empty ? 0.5 : 1, cursor: empty ? 'default' : 'pointer' }}>
      Ver preview
    </button>
  );
}

FaixaPreview.propTypes = {
  index: PropTypes.number,
  input: PropTypes.shape({
    value: PropTypes.any,
  }),
  onPreview: PropTypes.func,
};

const Results = function (props) {
  const {
    input: { onChange },
  } = props;
  const [open, setOpen] = useState(false);
  const [results, setResults] = useState([[0, 100]]);

  const lottiesList = props.lotties.list.content.map((item) => {
    return {
      label: item.name,
      value: item.id,
      url: item.url,
    };
  });

  lottiesList.unshift({
    label: 'Nenhuma Animação',
    value: 'none',
    url: 'none',
  });

  function handleResult(index) {
    setOpen(index);
  }

  function handleClose() {
    setOpen(false);
  }

  function valuetext(values) {
    return `${values}%`;
  }

  const handleChange = (event, v, index) => {
    const len = results.length;
    const newRange = [...results];
    for (let j = 0; j < len; j++) {
      if (j === index) {
        newRange[j] = v;
      } else if (j < index) {
        newRange[j] = [newRange[j][0], newRange[j + 1][0]];
      } else if (j > index) {
        newRange[j] = [newRange[j - 1][1], newRange[j][1]];
      }
    }
    newRange[0][0] = 0;
    newRange[len - 1][1] = 100;
    const newResults = [];
    for (const i in newRange) {
      if (i < props.input.value.length) {
        newResults.push({
          id: props.input.value[i].id,
          range: newRange[i],
        });
      } else {
        newResults.push({
          range: newRange[i],
        });
      }
    }
    onChange(newResults);
    setResults(newRange);
  };

  const handleClick = () => {
    const n = results.length + 1;
    const localResults = [];
    for (let i = 0; i < n; i++) {
      if (i === 0) {
        localResults.push([0, parseInt(100 / n)]);
      } else if (i === n - 1) {
        localResults.push([parseInt(localResults[i - 1][1]), 100]);
      } else {
        localResults.push([
          parseInt(localResults[i - 1][1]),
          parseInt(localResults[i - 1][1]) + parseInt(100 / n),
        ]);
      }
    }
    const newResults = [];
    for (const i in localResults) {
      if (i < props.input.value.length) {
        newResults.push({
          id: props.input.value[i].id,
          range: localResults[i],
        });
      } else {
        newResults.push({
          range: localResults[i],
        });
      }
    }
    onChange(newResults);
    setResults(localResults);
  };

  const handleClickRemove = () => {
    const n = results.length - 1;
    const localResults = [];
    for (let i = 0; i < n; i++) {
      if (i === 0) {
        localResults.push([0, parseInt(100 / n)]);
      } else if (i === n - 1) {
        localResults.push([parseInt(localResults[i - 1][1]), 100]);
      } else {
        localResults.push([
          parseInt(localResults[i - 1][1]),
          parseInt(localResults[i - 1][1]) + parseInt(100 / n),
        ]);
      }
    }
    const newResults = [];
    for (const i in localResults) {
      if (i < props.input.value.length) {
        newResults.push({
          id: props.input.value[i].id,
          range: localResults[i],
        });
      } else {
        newResults.push({
          range: localResults[i],
        });
      }
    }
    onChange(newResults);
    setResults(localResults);
  };

  useEffect(() => {
    if (props.input.value) {
      const ranges = props.input.value.map((item) => [
        parseInt(item.range[0]),
        parseInt(item.range[1]),
      ]);
      const localResults = props.input.value.map((item) => ({
        id: item.id,
        range: [parseInt(item.range[0]), parseInt(item.range[1])],
      }));
      onChange(localResults);
      setResults(ranges);
    }
  }, []);

  return (
    <>
      <Box style={{ margin: '12px 0' }}>
        <Typography style={{ fontSize: 16, fontWeight: 500 }} variant="subtitle2">
          Faixas de desempenho
        </Typography>
        <Typography style={{ fontSize: 13, color: '#666', margin: '4px 0 12px' }}>
          Divida a nota do quiz (% de acertos) em faixas. Para cada faixa, clique em “Configurar
          feedback” para definir a mensagem e a animação que o participante verá ao terminar. Use
          “Ver preview” para conferir a animação da faixa. Arraste os controles para ajustar os
          limites — as faixas são encadeadas, então mover um limite ajusta o vizinho.
        </Typography>
        <PrimaryButton style={{ margin: 0 }} onClick={handleClick}>
          Adicionar faixa
        </PrimaryButton>
      </Box>
      {results.map((item, index) => (
        <>
          <Container>
            <Box display="flex" alignItems="center" style={{ width: '100%', marginBottom: 4 }}>
              <Typography style={{ fontSize: 13, fontWeight: 600 }}>
                {`Faixa ${index + 1}: de ${results[index][0]}% a ${results[index][1]}% de acerto`}
              </Typography>
            </Box>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              style={{ width: '100%' }}>
              <Slider
                value={results[index]}
                style={{ margin: '0 0 0 10px' }}
                onChange={(event, v) => handleChange(event, v, index)}
                valueLabelDisplay="auto"
                aria-labelledby="range-slider"
                getAriaValueText={valuetext}
                marks={marks}
              />
              <button type="button" onClick={() => handleResult(index)}>
                Configurar feedback
              </button>
              <Field
                name={`feedback_lottie_id_${index}`}
                component={FaixaPreview}
                index={index}
                onPreview={props.setPreviewResult}
              />
              {index === results.length - 1 && results.length > 1 && (
                <FontAwesomeIcon
                  title="Remover última faixa"
                  style={{
                    cursor: 'pointer',
                    margin: 'auto 0 auto 8px',
                    fontSize: 16,
                  }}
                  icon={faTrash}
                  onClick={handleClickRemove}
                />
              )}
            </Box>
          </Container>
          <Dialog
            open={index === open}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description">
            <Box style={{ margin: 20 }}>
              <Field
                component={EditorConvertToHTMLActivity}
                label={'Feedback da pesquisa'}
                name={`result-${index}`}
                disabled={
                  props.router.params.action === 'proposta' ||
                  props.router.params.action === 'editar'
                }
                border
                validate={[FORM_RULES.required]}
              />
              <MaterialGrid item xs={12} style={{ marginTop: 30 }}>
                <Field
                  component={SelectLabel}
                  disabled={
                    props.router.params.action === 'proposta' ||
                    props.router.params.action === 'editar'
                  }
                  options={lottiesList}
                  name={`feedback_lottie_id_${index}`}
                  label="Escolha uma animação para feedback"
                />
              </MaterialGrid>
            </Box>
          </Dialog>
        </>
      ))}
    </>
  );
};

Results.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func,
    value: PropTypes.shape({
      length: PropTypes.any,
      map: PropTypes.func,
    }),
  }),
  lotties: PropTypes.shape({
    list: PropTypes.shape({
      content: PropTypes.shape({
        map: PropTypes.func,
      }),
    }),
  }),
  router: PropTypes.shape({
    params: PropTypes.shape({
      action: PropTypes.string,
    }),
  }),
  setPreviewResult: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    templates: state.templates,
    general: state.general,
    lotties: state.lotties,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ setPreviewResult }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Results);
